
import {GET_CHOICEQUESTIONDATA,GET_HOTQUESTIONDATA} from './mutation_types.js'
import strageList from '@/api/module/strageList'
import {toast} from 'assets/commonjs/toast';
import { getStore } from "assets/commonjs/storage";
export default {
   getStrageData({commit}){
       let userToken;
    if (getStore("userInfoAll") == undefined || getStore("userInfoAll") == null || getStore("userInfoAll") == ""){
        userToken=''
    }else{
        let userInfoAll = JSON.parse(getStore("userInfoAll"))
        userToken = userInfoAll.userToken
    }
    let data = {
        companyId:1,
        userToken:userToken
    }
    strageList.getIndexData(data).then(res =>{
        if(res.data && res.data.code == 0){
            commit(GET_CHOICEQUESTIONDATA,res.data.result.ansQuestionVoList ) 
            commit(GET_HOTQUESTIONDATA,res.data.result.ansTopicAnswerVoList  ) 
            
        }else{
            toast(res.data.message)
        }
    })
   }
}
